var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-modal',{attrs:{"open":_vm.show},on:{"close":function($event){return _vm.close()}}},[_c('div',{staticClass:"v-announce"},[_c('v-slider',{on:{"close":function($event){return _vm.close()}}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }